export var SwapCreateStep;
(function (SwapCreateStep) {
    SwapCreateStep["MainForm"] = "MainForm";
    SwapCreateStep["PendingSwaps"] = "PendingSwaps";
    SwapCreateStep["AuthorizeCoinbaseWithdrawal"] = "AuthorizeCoinbaseWithdrawal";
    SwapCreateStep["OffRampOAuth"] = "OffRampOAuth";
    SwapCreateStep["ApiKey"] = "ApiKey";
    SwapCreateStep["ActiveSwapLimit"] = "ActiveSwapLimit";
    SwapCreateStep["Error"] = "Error";
})(SwapCreateStep || (SwapCreateStep = {}));
export var SwapWithdrawalStep;
(function (SwapWithdrawalStep) {
    SwapWithdrawalStep["Withdrawal"] = "Withdrawal";
    SwapWithdrawalStep["CoinbaseManualWithdrawal"] = "CoinbaseManualWithdrawal";
    SwapWithdrawalStep["SwapProcessing"] = "SwapProcessing";
    SwapWithdrawalStep["ProcessingWalletTransaction"] = "ProcessingWalletTransaction";
    SwapWithdrawalStep["Success"] = "Success";
    SwapWithdrawalStep["Failed"] = "Failed";
    SwapWithdrawalStep["Error"] = "Error";
    SwapWithdrawalStep["Delay"] = "Delay";
    SwapWithdrawalStep["OffRampWithdrawal"] = "OffRampWithdrawal";
    SwapWithdrawalStep["WithdrawFromImtblx"] = "WithdrawFromImtblx";
    SwapWithdrawalStep["WithdrawFromStarknet"] = "WithdrawFromStarknet";
    SwapWithdrawalStep["SelectWithdrawalType"] = "SelectWithdrawalType";
    SwapWithdrawalStep["CoinbaseInternalWithdrawal"] = "CoinbaseInternalWithdrawal";
})(SwapWithdrawalStep || (SwapWithdrawalStep = {}));
export var MenuStep;
(function (MenuStep) {
    MenuStep["Menu"] = "Menu";
    MenuStep["Transactions"] = "Transactions";
    MenuStep["TransactionDetails"] = "Transaction Details";
    MenuStep["AddressBook"] = "Address Book";
    MenuStep["Campaigns"] = "Campaigns";
    MenuStep["CampaignDetails"] = "Campaign Details";
})(MenuStep || (MenuStep = {}));
export const ExchangeAuthorizationSteps = {
    "api_credentials": SwapCreateStep.ApiKey,
    "o_auth2": SwapCreateStep.AuthorizeCoinbaseWithdrawal
};
export const OfframpExchangeAuthorizationSteps = {
    "api_credentials": SwapCreateStep.ApiKey,
    "o_auth2": SwapCreateStep.OffRampOAuth
};
export class WizardStep {
}
